import jwt from "jwt-simple";
import environment from "../../config/environment";

const defaultExp = () => Date.now() + 300;

function encode(payload: unknown) {
  return jwt.encode(payload, environment.cryptoKey);
}

function decode(token: string, noVerify = false) {
  return jwt.decode(token, environment.cryptoKey, noVerify);
}

const securityToken = {
  defaultExp,
  encode,
  decode,
};

export default securityToken;
